(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noco-exhibition-archive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noco-exhibition-archive')) {
    customElements.define('noco-exhibition-archive', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-exhibition-close]');
          if (!button || !this.contains(button)) return;
          const exhibition = button.closest('details.noco-exhibition');
          if (!exhibition) return;
          exhibition.open = false;
          exhibition.querySelector('summary').focus();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;
          const exhibition = event.target.closest('details.noco-exhibition');
          if (exhibition) exhibition.open = true;
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
